import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";






const programmeEnrollmentGenerateMonth = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/enrollment-generate-month", data, headerConfig);
        return response;
};



const enrollmentJCPSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/enrollment-acction-jcp", data, headerConfig);
        return response;
};

const receiptListJCP = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/admission-receipt", data, headerConfig);
        return response;
};

const JCPenrollmentDatabyID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/enrollment-data", data, headerConfig);
        return response;
};

const JCPReceiptDatabyID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/receipt-master-data", data, headerConfig);
        return response;
};


const componentDetailsAgainstReceipt = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/receipt-details-data", data, headerConfig);
        return response;
};

const componentDetailsAgainstReceiptTap = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/receipt-details-data-tap", data, headerConfig);
        return response;
};


const enrollmentJCPMonthlySave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-receipt-entry-jcp", data, headerConfig);
        return response;
};


const enrollmentTAPSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/enrollment-action-tap", data, headerConfig);
        return response;
};


const tapBookingSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-booking", data, headerConfig);
        return response;
};



const enrollmentHPSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/enrollment-acction-hp", data, headerConfig);
        return response;
};

const enrollmentHpMonthlySave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-receipt-entry-hp", data, headerConfig);
        return response;
};

const enrollmentPhysicalFitnessSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/enrollment-acction-physicalfitness", data, headerConfig);
        return response;
};

const enrollmentPhysicalFitnessMonthlySave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-receipt-entry-pf", data, headerConfig);
        return response;
};

const tapMemberListTrainee = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-traineeList", data, headerConfig);
        return response;
};

const TournamentReceiptData = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "tournament/receipt-details-data", data, headerConfig);
        return response;
};

const MemberDiscountinue = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/member-discontinue", data, headerConfig);
        return response;
};


const enrollmentService = {
    enrollmentJCPSave,
    programmeEnrollmentGenerateMonth,
    receiptListJCP,
    JCPenrollmentDatabyID,
    JCPReceiptDatabyID,
    componentDetailsAgainstReceipt,
    enrollmentJCPMonthlySave,
    enrollmentTAPSave,
    tapBookingSave,
    componentDetailsAgainstReceiptTap,
    enrollmentHPSave,
    enrollmentHpMonthlySave,
    enrollmentPhysicalFitnessSave,
    enrollmentPhysicalFitnessMonthlySave,
    tapMemberListTrainee,
    TournamentReceiptData,
    MemberDiscountinue
  
};

export default enrollmentService;